<template>
	<div>
		<el-row>
			<el-col :lg="7" :md="9" :sm="12" :span="6" :xl="6" :xs="24">
				<img src="images/anze-product.png" style="width: 100%" />
			</el-col>
			<el-col :lg="16" :md="14" :sm="12" :span="18" :xl="18" :xs="24">
				<div style="margin-left: 16px">
					<h2>
						泰康
						<span style="color: red">电梯雇主</span>
						责任险
					</h2>
					<div style="color: red">电梯行业 | 行业超低价 | 全线上操作</div>
					<p>
						① 投保简便支持月单
						<br />
						② 3人起保，最高可保100万
						<br />
						③ 社保用药免赔100元后100%赔付
						<br />
					</p>
					<el-button size="medium" type="warning" @click.native="handleInsure">立即投保</el-button>
					<br />
					<el-button
						:loading="isDownLoading"
						icon="el-icon-download"
						size="medium"
						style="margin-top: 25px"
						type="text"
						@click.native="handleDownLoad">
						下载泰康险职业类别表
					</el-button>
				</div>
			</el-col>
		</el-row>
		<el-tabs v-model="currentStep">
			<el-tab-pane label="保险详情" name="0">
				<el-card>
					<avue-crud ref="plan" :data="dataPlan" :option="optionPlan" :span-method="spanMethodPlan"></avue-crud>
				</el-card>
				<el-card>
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">短期保费=年保费*比例</span>
					</el-row>
					<avue-crud ref="crud" :data="dataBenefit" :option="optionTKDQ">
						<template slot="header"></template>
					</avue-crud>
				</el-card>
				<el-card header="批增保费">
					<el-row justify="center" type="flex">
						<span style="font-weight: 500; color: Red; margin-bottom: 20px">
							批增保费=（每人保费*（剩余保险天数/总保险天数））*人数
						</span>
					</el-row>
				</el-card>
			</el-tab-pane>

			<el-tab-pane label="常见问题" name="1">
				<el-row>
					<el-col :span="20">
						<ul>
							<li v-for="qa in dataQA" :key="qa.question">
								<div>
									<span class="start-zimu">Q</span>
									<span style="font-weight: bold">
										{{ qa.question }}
									</span>
								</div>
								<p></p>
								<div>
									<span class="start-zimu" style="background-color: MediumSeaGreen">A</span>
									<span v-if="qa.question === '泰康在线的电梯雇主责任险保险责任范围包括哪些？'">
										<span>
											在保险期间内，凡被保险人的雇员在中华人民共和国境内（不包括港、澳、台地区）因下列情形所致伤、残或死亡，依照中华人民共和国法律（不包括港、澳、台地区法律）应由被保险人承担的经济赔偿责任，保险人按照本保险合同约定负责赔偿：
										</span>
										<br />
										<span>（一）在工作时间和工作场所内，因工作原因发生意外事故受到伤害；</span>
										<br />
										<span>
											（二）工作时间前后在工作场所内，从事与工作有关的预备性或者收尾性工作因意外事故受到伤害；
										</span>
										<br />
										<span>（三）在工作时间和工作场所内，因履行工作职责受到暴力等意外伤害；</span>
										<span>（四）被诊断、鉴定为职业病；</span>
										<br />
										<span>（五）因公外出期间，由于工作原因受到伤害或者发生事故下落不明；</span>
										<br />
										<span class="red-bold">（六）在上下班途中，因发生交通及其他意外事故受到伤害；</span>
										<br />
										<span class="red-bold">
											（七）在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡；
										</span>
										<br />
										<span>（八）在抢险救灾等维护国家利益、公共利益活动中受到伤害；</span>
										<br />
										<span>
											（九）原在军队服役，因战、因公负伤致残，已取得革命伤残军人证，到被保险人处工作后旧伤复发；
										</span>
										<br />
										<span>（十）法律、行政法规规定应当认定为工伤的其他情形。</span>
										<br />
									</span>

									<span v-else-if="qa.question === '泰康在线电梯雇主责任险有哪些责任不保？'">
										<span>以下情况不属于保险责任。</span>
										<br />
										<span style="font-weight: bold">一、下列原因造成雇员伤、残或死亡的，保险人不负责赔偿：</span>
										<br />
										<span>（一）投保人、被保险人及其代表的故意和重大过失行为；</span>
										<br />
										<span>（二）战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动、恐怖活动；</span>
										<br />
										<span>（三）核辐射、核爆炸、核污染及其他放射性污染；</span>
										<br />
										<span>（四）大气污染、土地污染、水污染及其他各种污染；</span>
										<br />
										<span>（五）地震及其次生灾害、海啸及其次生灾害、飓风及其次生灾害；</span>
										<br />
										<span>（六）非被保险人的雇员所遭受的伤害；</span>
										<br />
										<span>（七）行政行为或司法行为；</span>
										<br />
										<span>（八）被保险人雇员接触、使用含有放射性物质的材料；</span>
										<br />
										<span>（九）被保险人雇员接触、使用石棉、石棉制品或含有石棉成份的物质；</span>
										<br />
										<span>（十）被保险人雇员患职业病以外的疾病、传染病、分娩、流产、药物过敏。</span>
										<br />
										<span style="font-weight: bold">二、雇员发生下列情形并导致伤、残或死亡的，保险人不负责赔偿：</span>
										<br />
										<span>（一）故意行为、犯罪行为、违反治安管理法律、法规和规章；</span>
										<br />
										<span>（二）自伤、自杀、打架、斗殴；</span>
										<br />
										<span>（三）因受酒精、毒品、药品影响造成自身人身伤亡；</span>
										<br />
										<span>
											（四）无驾驶证、驾驶证失效或者被依法扣留、暂扣、吊销、注销期间驾驶机动车，驾驶与驾驶证载明的准驾车型不相符合的机动车，持审验不合格的驾驶证驾驶机动车；
										</span>
										<br />
										<span class="red-bold">
											（五）无国家有关部门核发的有效操作资格证而使用各种专用机械、特种设备或特种车辆或类似设备装置的；
										</span>
										<br />
										<span>
											（六）从事潜水、跳伞、热气球运动、攀岩运动、探险活动、武术比赛、摔跤比赛、特技表演、赛马、赛车等高风险活动；
										</span>
										<br />
										<span>
											（七）在中华人民共和国境外（包括香港、澳门、台湾地区）所发生的被保险人雇员的伤、残或死亡；
										</span>
										<br />
										<span>（八）在被保险人被依法取缔、关闭或吊销营业执照期间发生的伤、残或死亡。</span>
										<br />
										<span style="font-weight: bold">三、对于下列损失、费用或责任，保险人不负责赔偿：</span>
										<br />
										<span>（一）被保险人的承包商或分包商的工作人员所遭受的伤害；</span>
										<br />
										<span>（二）在被保险人工作场所内实习、进修人员所遭受的伤害；</span>
										<br />
										<span>
											（三）除本保险合同列明负责赔偿的项目外，其他超出被保险人雇员所在地工伤保险和基本医疗保险诊疗项目目录、药品目录、医疗服务设施范围和支付标准的医疗费用；
										</span>
										<br />
										<span>（四）精神损害赔偿；</span>
										<br />
										<span>（五）间接损失；</span>
										<br />
										<span>（六）罚款、罚金及惩罚性赔偿；</span>
										<br />
										<span>
											（七）在合同或协议中约定的应由被保险人承担的赔偿责任，但即使没有这种合同或协议，被保险人依法仍应承担的赔偿责任不在本款责任免除范围内；
										</span>
										<br />
										<span>（八）保险单中载明的应由被保险人自行承担的免赔额或按保险单载明的免赔率计算的免赔额。</span>
										<br />
									</span>
									<span v-else-if="qa.question === '该保险产品有多少种保险期限可选择？如何收费？'">
										<span>共有12种保险期限可选择，1个月-12个月均可选择。</span>
										<br />
										<span style="display: inline-block; margin-left: 25px; font-weight: bold; margin-bottom: 10px">
											短期保单保费=年保费*比例。
										</span>
										<br />
										<table border="1" cellpadding="10">
											<tr>
												<th v-for="item in monthData">
													{{ item }}
												</th>
											</tr>
											<tr>
												<td v-for="item in rateData">
													{{ item }}
												</td>
											</tr>
										</table>
									</span>
									<span v-else>{{ qa.answer }}</span>
								</div>
								<el-divider></el-divider>
							</li>
						</ul>
					</el-col>
				</el-row>
			</el-tab-pane>

			<el-tab-pane label="投保须知" name="2">
				<el-row>
					<el-col :span="20">
						<h3>保险条款及须知</h3>
						<p style="line-height: 32px">
							<span>
								本产品由泰康在线财产保险股份有限公司（以下简称“泰康在线”）承保，由泰康在线委托博维保险经纪（以下简称“博维”）有限公司进行销售
								<br />
								<span class="link">
									互联网保险信息披露访问链接：
									<a href="http://icid.iachina.cn/?columnid_url=201509301401" style="color: DodgerBlue" target="_blank">
										http://icid.iachina.cn/?columnid_url=201509301401
									</a>
								</span>
							</span>
							<span>
								泰康在线是世界500强泰康保险集团的全资子公司，成立于2015年，注册资本为人民币40亿元。截至2020年末，公司综合偿付能力充足率209%。泰康在线专注于互联网保险业务的创新开拓，致力于通过“保险+科技”、“保险+服务”的“双生态”战略，，实现保险与科技的深度融合保险金融属性和服务属性的深度结合，打造国际领先的科技型、服务型互联网保险公司。
							</span>
						</p>
						<p style="line-height: 32px">
							<span style="font-weight: bold">一、重要告知</span>
							<br />
							1.1 订立本合同时，投保人应明确了解如下内容，投保人签订保险合同即视为了解并同意如下内容。
							<br />
							1.2
							<span class="red-bold">投保前请仔细阅读保险特别约定、保险条款及其中责任免除部分。</span>
							<br />
							1.3 保险人就投保人和被保险人的有关情况提出询问，投保人应当如实告知。
							<br />
							1.4
							<span class="red-bold">
								如投保人故意或者因重大过失未履行前款规定的如实告知义务，根据条款约定足以影响合同是否成立或者提高保险费率的，保险人有权解除本合同。
							</span>
							<br />
							1.5
							<span class="red-bold">
								如投保人故意不履行如实告知义务，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，并不退还保险费。
							</span>
							<br />
							1.6
							<span class="red-bold">
								如投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，对于本合同解除前发生的保险事故，保险人不承担给付保险金的责任，
							</span>
							但应当退还保险费。
							<br />
							1.7
							保险人在合同订立时已经知道投保人未如实告知的情况的，保险人不得解除合同；发生保险事故的，保险人应承担给付保险金的责任。
							<br />
							1.8 保险公司全国统一的客户服务及投诉方式详见如下链接
							<br />
							<span class="link">
								<a href="http://www.tk.cn/sales/feedback-pc/page/" style="color: DodgerBlue" target="_blank">
									http://www.tk.cn/sales/feedback-pc/page/
								</a>
							</span>
							1.9
							本保险合同以电子保单形式提供。根据《中华人民共和国民法典》规定，数据电文是合法的合同表现形式，与纸质合同具有同样的法律效力。
							<br />
							2.0 本保险根据投保单位的需求提供电子发票或纸质专票。
							<br />
							2.1
							<span class="red-bold">
								本保险由博维保险经纪有限公司面向全国销售并提供服务，如有其他疑问，请在投保前联系客服热线400-180-1616进行咨询与确认。
							</span>
							<br />
						</p>
						<el-divider></el-divider>
						<h3>特别约定</h3>
						<div style="line-height: 32px">
							1、本产品承保的雇员年龄范围为16周岁-65周岁，其中电梯安装和电梯维修人员的年龄范围为16周岁-55周岁。
							<br />

							2、本保单扩展24小时人身意外伤害扩展保险条款，该附加险项下每人责任限额为5万元人民币。
							<br />
							3、本保单扩展第三者责任保险，该附加险项下每次事故责任限额为5万元人民币。
							<br />
							4、本保单赔偿范围包括雇员误工费，
							<span class="red-bold">
								经医院证明，对于超过五天期间的误工损失按100元/天的标准赔偿误工费用，赔偿公式为：100x(实际暂时丧失工作能力天数
								- 5天)，每次不超过90天，累计不超过180天。
							</span>
							<br />
							5、
							<span class="red-bold">
								主险条款第四条第七款（雇员在工作时间和工作岗位，突发疾病死亡或者在48小时之内经抢救无效死亡）赔偿限额为每人每次死亡伤残赔偿限额的20%。
							</span>
							<br />
							6、保单累计责任限额为实际投保人数*每人伤亡责任限额，
							<span class="red-bold">累计责任限额最高不超过1000万，每次事故责任限额最高不超过500万；</span>
							法律费用另计，不含在内
							<br />

							7、工伤事故身故、残疾理赔约定：理赔时提供投保人所在地劳动保障行政部门出具的工伤认定证明、劳动能力鉴定委员会做出的劳动能力鉴定结论，劳动能力鉴定材料（
							<span class="red-bold">
								如无法提供劳动保障行政部门出具的工伤认定证明，则伤残赔付标准为保单约定赔付金额的50%）。
							</span>
							<br />
							8、除受伤当日紧急抢救外，必须在二级以上（含）公立医院就诊，急诊客户除受伤当日因紧急救治可就近送医外，后续治疗均需转至二级（或二级以上）公立医院。未遵循前述约定的，保险人有权拒绝赔付。
							<br />
							9、
							<span class="red-bold">
								对于进行电梯井道与结构作业的安装工人，本保单只承保其在进行电梯施工工作发生的保险事故，
							</span>
							进行其他施工过程中发生的保险事故为除外责任。
							<br />
							10、从事高空作业人员，必须定期进行身体检查，被保险人的雇员无妨碍从事相应特种作业的器质性心脏病、癫痫病、美尼尔氏症、眩晕症、癔病、震颤麻痹症、精神病、痴呆症以及其它不适应高空作业的人，不得从事高空作业；
							<span class="red-bold">
								从事高空作业必须配带安全带、安全帽、孔洞须加强围栏或防滑措施，如存在前述疾病或未遵守签署高空作业防范措施，保险公司有权拒绝赔付。
							</span>
							<br />
							10、
							<span class="red-bold">
								出险索赔时，对于电梯维修人员，需提供电梯操作证，对于电梯安装工人，需提供岗前培训通过证明文件，否则保险人有权拒绝赔偿。
							</span>
							<br />
							11、
							<span class="red-bold">
								北京平谷区密云区、河北省承德市兴隆县中医院、河北省三河市、天津市、辽宁铁岭、河北青龙县、廊坊市、山东禹城、河南信阳下辖的各医疗机构，不在保险公司认可医院范围内，即上述地区医疗机构的发票保险公司不予理赔。
							</span>
							<br />
							12、
							<span class="red-bold">已出险人员（含已报案未理赔和已理赔）不允许变更。</span>
							<br />
							13、伤残鉴定及给付标准：
							<br />
							1）因工作原因导致的意外事故，提供工伤认定并根据《劳动能力鉴定职工工伤与职业病致残等级》（GB/T16180-2014）确定的伤残程度，给付比例表如下：
							<table border="1" cellpadding="10">
								<tr>
									<th v-for="(item, index) in leavelData" :key="index">
										{{ item }}
									</th>
								</tr>
								<tr>
									<td v-for="(item, index) in leavelValueData" :key="index">
										{{ item }}
									</td>
								</tr>
							</table>
							2）非工作时间发生的意外事故，按照《人身保险伤残评定标准及代码》（标准编号为JR/T0083-2013)
							确定的伤残程度，给付比例如下：
							<table border="1" cellpadding="10">
								<tr>
									<th v-for="(item, index) in leavelData" :key="index">
										{{ item }}
									</th>
								</tr>
								<tr>
									<td v-for="(item, index) in leavelValueData" :key="index">
										{{ item }}
									</td>
								</tr>
							</table>
						</div>
					</el-col>
				</el-row>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import {currentYYYYmmdd} from '@/util/date'
import {handleDownCategoryFile} from '@/util/util'
import {
	optionAddFeeRate,
	optionPremium,
	optionPremiumRestrict,
	optionTaiKangDT,
	optionTKDQ,
} from '@/const/crud/insurance/productDetail'

export default {
	name: 'Product18Details',
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
	},
	data: function () {
		return {
			currentStep: '0',
			optionPlan: optionTaiKangDT,
			optionPremium: optionPremium,
			optionPremiumRestrict: optionPremiumRestrict,
			optionTKDQ: optionTKDQ,
			optionAddFeeRate: optionAddFeeRate,
			dataPlan: [
				{
					insuredItem: '投保工种',
					plan1: '电梯安装人员、电梯维修保养人员、企业管理人员',
				},
				{
					insuredItem: '投保年龄',
					plan1: '企业管理人员：16-65周岁 电梯安装人员、电梯维修保养人员：16-55周岁',
				},
				{
					insuredItem: '身故伤残限额',
					plan1: '50万',
					plan2: '80万',
					plan3: '100万',
				},
				{
					insuredItem: '医疗限额（每人每次事故免赔100元）',
					plan1: '5万',
					plan2: '8万',
					plan3: '10万',
				},
				{
					insuredItem: '误工费/天（每人每次事故免赔5天）',
					plan1: '100元/天',
				},
				{
					insuredItem: '法律费用累计责任限额',
					plan1: '20万',
				},
				{
					insuredItem: '三者责任限额（每次事故免赔500元）',
					plan1: '5万',
				},
				{
					insuredItem: '附加24小时意外（每次事故免赔500元）',
					plan1: '5万',
				},
				{
					insuredItem: '保费（/人/年）',
					plan1: '800元',
					plan2: '1200元',
					plan3: '1500元',
				},
			],
			dataBenefit: [
				{
					levelItem: '比例',
					level1: '30%',
					level2: '30%',
					level3: '30%',
					level4: '40%',
					level5: '50%',
					level6: '60%',
					level7: '70%',
					level8: '80%',
					level9: '85%',
					level10: '90%',
					level11: '95%',
					level12: '100%',
				},
			],
			dataQA: [
				{
					question: '本产品的保险公司是哪家？',
					answer: '由世界500强泰康保险集团的全资子公司—泰康在线财产保险股份有限公司承保。',
				},
				{
					question: '泰康在线的电梯雇主责任险保险责任范围包括哪些？',
					answer: '',
				},
				{
					question: '泰康在线电梯雇主责任险有哪些责任不保？',
					answer: '',
				},
				{
					question: '哪类组织可以成为该保险产品的投保人和被保险人？',
					answer:
						'依法设立的各类机关、企事业单位、社会团体、个体工商户及其他经济组织均可作为本保险合同的投保人和被保险人。投保人和被保险人必须为同一单位。',
				},
				{
					question: '该产品需要几人才能投保？',
					answer: '该产品最少需要3人方可投保。',
				},
				{
					question: '该产品被保险人的雇员是指什么？',
					answer:
						'本保险产品所称雇员，是指与被保险人存在劳动关系（包括事实劳动关系）的各种用工形式、各种用工期限的年满十六周岁的劳动者及其它按国家规定和法定途径审批的劳动者。',
				},
				{
					question: '该产品被保险人的雇员承保年龄是多少？',
					answer: '企业管理人员16-65周岁，电梯安装和电梯维修人员16-55周岁。',
				},
				{
					question: '该保险产品承保什么行业人员？有什么拒保行业。',
					answer: `该保险产品是为电梯行业的电梯安装人员、电梯维修保养人员、企业管理人员打造的产品。\n不属于以上三类人员的单位请勿投保此产品，不慎投保的企业，请联系平台工作人员，尽快为您办理退保手续。\n若有其他行业投保需求的单位，请咨询平台工作人员，由专业客服为您解答。`,
				},
				{
					question: '该保险产品有多少种保险期限可选择？如何收费？',
					answer: '',
				},
				{
					question: '雇员变动怎么办？',
					answer: `本保险产品不可减人，可加人，加人时批增保费按日批增计费。
  保险期限1-3个月的保单不可换人，保险期限超过3个月的保单可以换人。替换时，电梯安装人员可替换为新电梯安装人员，维修保养人员可替换为新维修保养人员，企业管理人员可替换为新的企业管理人员。\n不分节假日，全天24小时，均可线上直接替换或新增人员。`,
				},
				{
					question: '投保后，保单最快起保生效时间是什么时候？批增和替换最快起保生效时间是什么时候？',
					answer:
						'该产品投保时最快生效时间是T+2。如客户在2022年11月17日内的任意时间内投保，保单最快生效时间是2022年11月19日0时。\n该产品批增/替换时最快生效时间是T+1。如客户在2022年11月17日内的任意时间内批增/替换，批单最快生效时间是2022年11月18日0时。',
				},
				{
					question: '出险员工是否可替换出去？',
					answer: '已出险人员（含已报案未理赔和已理赔）无法替换。',
				},
				{
					question: '怎么投保？怎么支付？',
					answer: '直接用电脑在此网页上操作即可，具体流程：选方案→填信息→线上支付保费→获取保单。',
				},
				{
					question: '保单和发票怎么获取？',
					answer:
						'线上投保完成后实时出具电子保单，如果客户选择普票则实时出具电子普票，当客户选择专票时，由泰康在线开具专票后进行邮寄。',
				},
				{
					question: '保单如何查验真伪？',
					answer:
						'可以通过拨打泰康在线全国客服电话95522-3-3-1进行人工查询或者登录泰康在线客服中心网站输入保单号、投保人证件号进行自助查询https://www.tk.cn/scsy/bdzzcx/',
				},
			],
			monthData: [
				'月份',
				'1个月',
				'2个月',
				'3个月',
				'4个月',
				'5个月',
				'6个月',
				'7个月',
				'8个月',
				'9个月',
				'10个月',
				'11个月',
				'12个月',
			],
			leavelData: ['一级', '二级', '三级', '四级', '五级', '六级', '七级', '八级', '九级', '十级'],
			leavelValueData: ['100%', '80%', '70%', '60%', '40%', '30%', '20%', '15%', '7%', '5%'],

			rateData: ['比例', '30%', '30%', '30%', '40%', '50%', '60%', '70%', '80%', '85%', '90%', '95%', '100%'],
			isDownLoading: false,
		}
	},
	created() {},
	methods: {
		spanMethodPlan({row, column, rowIndex, columnIndex}) {
			if (columnIndex == 1 || columnIndex == 2 || columnIndex == 3) {
				if (rowIndex == 0 || rowIndex == 1 || rowIndex == 4 || rowIndex == 5 || rowIndex == 6 || rowIndex == 7) {
					return {
						rowspan: 1,
						colspan: 3,
					}
				}
			}

			// // if (
			// //   rowIndex === 0 ||
			// //   rowIndex === 1 ||
			// //   rowIndex === 4 ||
			// //   rowIndex === 5 ||
			// //   rowIndex === 6 ||
			// //   rowIndex === 7 ||
			// //   rowIndex === 8
			// // ) {
			// //   if (columnIndex === 2) {
			// //     return [1, 11];
			// //   }
			// // }
			// if (columnIndex === 0) {
			//   if (rowIndex >= 9 && rowIndex <= 16) {
			//     if (columnIndex === 0) {
			//       if (rowIndex % 2 === 1) {
			//         return {
			//           rowspan: 2,
			//           colspan: 1,
			//         };
			//       } else {
			//         return {
			//           rowspan: 0,
			//           colspan: 0,
			//         };
			//       }
			//     }
			//   }
			// }
			// if (rowIndex > 17) {
			//   if (columnIndex === 2) {
			//     // return [1, 11]
			//     return {
			//       rowspan: 3,
			//       colspan: 4,
			//     };
			//   } else if (columnIndex > 2) {
			//     return {
			//       rowspan: 0,
			//       colspan: 0,
			//     };
			//   }
			// }

			// if (rowIndex < 9) {
			//   if (columnIndex === 0) {
			//     return [1, 2];
			//   } else if (columnIndex === 1) {
			//     return [0, 0];
			//   }
			// }
		},
		handleInsure() {
			this.$emit('insure')
		},
		handleDownLoad() {
			this.isDownLoading = true
			let fileName = `tk_${this.productId}_template_chinalife_${currentYYYYmmdd()}.xlsx`
			handleDownCategoryFile(
				`/dist/distInsure/categoryDownloadDetail
  /${this.productId}`,
				{},
				fileName,
			)
				.then(() => {
					//下载成功
				})
				.finally(() => {
					this.isDownLoading = false
				})
		},
	},
}
</script>

<style lang="scss" scoped>
.start-zimu {
	display: inline-block;
	width: 20px;
	text-align: center;
	color: white;
	padding: 4px;
	border-radius: 4px;
	margin-right: 8px;
	background-color: mediumpurple;
}

.red-bold {
	color: red;
	font-weight: bold;
}

.el-col {
	font-size: 14px;
}

.el-card {
	font-size: 14px;
	margin-bottom: 16px;
}

.item {
	margin-bottom: 18px;
}

.ul,
li {
	list-style: none;
}

span.link {
	display: block;
	text-indent: 1em;
}

h2 {
	margin: 0px;
	padding: 0px;
}
</style>
